/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RegimenCycle from './regimen-cycle';
import RegimenCycleDetail from './regimen-cycle-detail';
import RegimenCycleUpdate from './regimen-cycle-update';
import RegimenCycleDeleteDialog from './regimen-cycle-delete-dialog';

const RegimenCycleRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RegimenCycle />} />
    <Route path="new" element={<RegimenCycleUpdate />} />
    <Route path=":id">
      <Route index element={<RegimenCycleDetail />} />
      <Route path="edit" element={<RegimenCycleUpdate />} />
      <Route path="delete" element={<RegimenCycleDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RegimenCycleRoutes;
